module.exports = __webpack_public_path__ + "static/media/dissectingSelf.fe973512.jpg";